// extracted by mini-css-extract-plugin
export default {"photoContainer":"PhotoReorder_photoContainer__lyz20","item":"PhotoReorder_item__LPZbS"};